<!-- eslint-disable -->
<template>
  <div class="click-confirm-container">
    <!-- Main button content -->
    <div
      class="main-button-wrapper"
      @click="handleInitialClick"
    >
      <slot></slot>
    </div>

    <!-- Confirmation tooltip -->
    <div v-if="showConfirm" class="confirmation-tooltip">
      <div class="tooltip-content">
        <div class="tooltip-question">Are you sure?</div>
        <div class="tooltip-buttons">
          <b-button 
            :class="yesClass" 
            @click="confirm" 
            size="sm"
            class="tooltip-btn tooltip-btn-yes"
          >
            {{ yesText }}
          </b-button>
          <b-button 
            :class="noClass" 
            @click="cancel" 
            size="sm"
            class="tooltip-btn tooltip-btn-no"
          >
            {{ noText }}
          </b-button>
        </div>
      </div>
      <div class="tooltip-arrow"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClickConfirm',
  props: {
    yesClass: { type: String, default: 'btn btn-danger' },
    noClass: { type: String, default: 'btn btn-default' },
    yesText: { type: String, default: 'Yes' },
    noText: { type: String, default: 'No' },
    buttonClass: { type: String, default: '' }
  },
  data () {
    return {
      showConfirm: false
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleInitialClick (event) {
      // Prevent the original click event from firing
      event.preventDefault()
      event.stopPropagation()

      // Show the confirmation tooltip
      this.showConfirm = true
    },
    confirm () {
      // Emit the confirm event
      this.$emit('confirm')

      // Hide the tooltip
      this.showConfirm = false
    },
    cancel () {
      this.$emit('cancel')
      this.showConfirm = false
    },
    handleClickOutside (event) {
      if (this.showConfirm && !this.$el.contains(event.target)) {
        this.showConfirm = false
      }
    }
  }
}
</script>

<style scoped>
.click-confirm-container {
  position: relative;
  display: inline-block;
}

.main-button-wrapper {
  display: inline-block;
  cursor: pointer;
}

.confirmation-tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
  z-index: 1000;
}

.tooltip-content {
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 12px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  text-align: center;
}

.tooltip-question {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 500;
}

.tooltip-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.tooltip-btn {
  min-width: 50px;
  font-size: 12px;
  padding: 4px 12px;
}

.tooltip-btn-yes {
  background-color: #28a745 !important;
  border-color: #28a745 !important;
  color: white !important;
}

.tooltip-btn-yes:hover {
  background-color: #218838 !important;
  border-color: #1e7e34 !important;
}

.tooltip-btn-no {
  background-color: white !important;
  border-color: #ddd !important;
  color: #333 !important;
}

.tooltip-btn-no:hover {
  background-color: #f8f9fa !important;
  border-color: #ccc !important;
}

.tooltip-arrow {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid white;
}

.tooltip-arrow::before {
  content: '';
  position: absolute;
  top: -9px;
  left: -9px;
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-top: 9px solid #ddd;
  z-index: -1;
}
</style>
